import { mapState, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import templateAddEditContent from '@/components/pages/main-pages/settings/templates/template-add-edit-content/template-add-edit-content.vue'

export default {
  components: {
    templateAddEditContent
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      template: {}
    }
  },
  computed: {
    ...mapState('template', ['ageOptions']),
    ...mapState('competitionMechanic', ['mechanicList']),
    ...mapState('workflow', ['workflowList'])
  },
  methods: {
    ...mapActions('template', ['updateTemplate', 'deleteTemplate']),
    onUpdateTemplate: async function () {
      try {
        const editedTemplate = cloneDeep(this.template)
        editedTemplate.mechanic_id = editedTemplate.mechanic.id
        delete editedTemplate.mechanic
        editedTemplate.age = editedTemplate.age.name
        await this.updateTemplate(editedTemplate)
        this.$notify({
          text: 'Template updated',
          type: 'success'
        })
        this.data.edit(this.data.id)
        this.data.refresh()
      } catch (e) {
        this.$notify({
          text: 'Error while updating template',
          type: 'error'
        })
      }
    },
    cancel: function () {
      this.data.edit(this.data.id)
    },
    onDelete: async function () {
      try {
        await this.$dialog.confirm(
          `This action may affect ongoing competitions. Do you really want to delete template ${this.template.name}?`
        )
        await this.deleteTemplate({
          id: this.template.id
        })
        this.$notify({
          text: 'Template deleted',
          type: 'success'
        })
        this.data.edit(this.data.id)
        this.data.refresh()
      } catch (error) {
        this.$notify({
          text: 'Error while deleting template',
          type: 'error'
        })
      }
    }
  },
  async created() {
    this.template = cloneDeep(this.data)
    this.template.age = this.ageOptions.filter((age) => age.name === this.template.age)[0]
    this.template.mechanic = this.mechanicList.filter((mechanic) => mechanic.id === this.template.mechanic_id)[0]
    this.template.workflow = this.workflowList.data.filter((workflow) => workflow.id === this.template.workflow_id)[0]
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/templates/template-edit/template-edit.js